import React from 'react';
import OverdueAgingReasonCell from './shared/OverdueAgingReasonCell';

const Section3 = ({
  mode,
  collapsedSections,
  renderSectionHeader,
  overdueAgingBucketData,
  allReasonsData,
  isLoadingReasons,
  handleOpenReasonModal,
  canAddReason,
  onSubmitReasonInline,
  isSubmittingReason,
  sectionNote
}) => {
  // Filter reasons for Overdue Aging topic
  const overdueAgingReasons = Array.isArray(allReasonsData)
    ? allReasonsData.filter((reason) => reason.topic === 'Overdue Aging')
    : [];

  // Helper function for days badge color
  const getDaysBadgeColor = (days) => {
    if (days >= 60) return 'bg-red-100 text-red-800';
    if (days >= 45) return 'bg-yellow-100 text-yellow-800';
    return 'bg-blue-100 text-blue-800';
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      {renderSectionHeader(3, 'Overdue Aging Bucket')}
      {(mode === 'view' || !collapsedSections[3]) && (
        <div className="overflow-x-auto">
          {overdueAgingBucketData?.data?.invoices?.length === 0 ? (
            <div className="flex justify-center items-center h-[8rem]">
              <p className="text-sm text-gray-500">No data available</p>
            </div>
          ) : (
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Customer Name
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Days Delayed
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Amount
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Sales Person
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-[40rem]">
                    Comment
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {overdueAgingBucketData?.data?.invoices?.map((row, index) => (
                  <tr key={index}>
                    <td className="px-4 py-3 text-sm text-gray-900">
                      {row.closedDeal?.lead?.user?.name || 'N/A'}
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium ${getDaysBadgeColor(row.daysDelayed)}`}>
                        {row.daysDelayed || 0} days
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900">
                      ₹{(Number(row.amount) - Number(row.paid_amount)).toFixed(2)}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {row.closedDeal?.lead?.sales?.name || 'N/A'}
                    </td>
                    <OverdueAgingReasonCell
                      row={row}
                      mode={mode}
                      handleOpenReasonModal={handleOpenReasonModal}
                      overdueAgingReasonsData={{ data: overdueAgingReasons }}
                      isLoadingOverdueAgingReasons={isLoadingReasons}
                      canAddReason={canAddReason}
                      onSubmitReasonInline={onSubmitReasonInline}
                      isSubmittingReason={isSubmittingReason}
                    />
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
      {/* Section Note */}
      {sectionNote && (
        <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="flex items-start gap-2">
            <svg
              className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <h4 className="text-sm font-semibold text-gray-900">
                  {sectionNote.user?.vertical || 'Management'} notes
                </h4>
                <div className="inline-flex items-center gap-1 px-2 py-0.5 bg-gray-100 rounded-full">
                  <span className="text-xs text-gray-600">By</span>
                  <span className="text-xs font-medium text-gray-900">
                    {sectionNote.user?.name || 'Unknown User'}
                  </span>
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{sectionNote.note}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Section3;
